import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  
  SETTINGS_DATA,
  SETTINGS_SAVE
} from "./actionTypes";
import {
  apiError,
  getSettingsSuccessful,
  
} from "./actions";

import {
  // postAdd,
  getList,
  // getParamsList,
  postEdit,
  // postDelete,
} from "../../helpers/Helper";
import swal from "sweetalert";

function* getSettings() {
  try {
    const response = yield call(
      getList,
      "/system/settings/1",
      {}
    );
    yield put(getSettingsSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}


//If user is login then dispatch redux action's are directly from here.
function* SaveSettings({ payload: { data } }) {
  try {
    const response = yield call(
      postEdit,
      "/system/settings/1",
      data
    );
    if (response.status === 200) {
      swal("Settings Updated Successfully.!", {
        icon: "success",
        timer: 1500,
      });
      // yield put(getBasicUnits());
    } else {
      swal("Sorry! Unable to Update Settings. Please Try Again!", {
        icon: "error",
      });
    }
    // yield put(BasicUnitAddSuccessful(null));
  
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });
    //yield put(apiError(error));
  }
}

export function* watchgetSettings() {
  yield takeEvery(SETTINGS_DATA, getSettings);
}

export function* watchSaveSettings() {
  yield takeEvery(SETTINGS_SAVE, SaveSettings);
}


function* DashboardSaga() {
  yield all([
    fork(watchgetSettings),
    fork(watchSaveSettings),
  ]);
}

export default DashboardSaga;
